module.exports = __webpack_public_path__ + "img/cant-find-shopping-receipts.d0f1e44f.png";